// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {useState} from 'react'
import type {Country} from './types'

export function useConsentExperience(initialCountry: Country | null = null) {
  const [isConsentExperienceValid, setConsentExperienceValidation] = useState(true)
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(initialCountry)

  const onConsentExperienceValidationChange = (isValid: boolean) => {
    setConsentExperienceValidation(isValid)
  }

  return {
    isConsentExperienceValid,
    onConsentExperienceValidationChange,
    selectedCountry,
    setSelectedCountry,
  }
}
